import { ButtonsGroup, RadioButtonsSkeleton } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { NotionalType } from 'models/common/notional';
import { FC, useContext } from 'react';

import { AddonMainFormContext } from '../AddonMainForm.context';

interface OwnProps {
  notionalType?: NotionalType;
  notionalTypes: NotionalType[];
  visible: boolean;
  onChange: (newNotionalType: NotionalType) => void;
}

export const NotionalTypeComponent: FC<OwnProps> = ({ notionalType, notionalTypes, visible, onChange }) => {
  const { isLoading, isReadOnly } = useContext(AddonMainFormContext);

  if (!visible) {
    return null;
  }
  return (
    <BlockOrientationFormGroup inputId="notionalType" label="addon.notionalType">
      {!isLoading && notionalType !== undefined && (
        <ButtonsGroup
          className="w-100"
          items={notionalTypes}
          onSelect={newValue => {
            if (newValue[0] === 'Currency') {
              onChange('Currency');
            } else {
              onChange('Units');
            }
          }}
          selectedItems={notionalType}
          translationPrefix="addon"
          isDisabled={isReadOnly}
          isRadio
        />
      )}
      {isLoading && <RadioButtonsSkeleton items={notionalTypes} />}
    </BlockOrientationFormGroup>
  );
};

NotionalTypeComponent.displayName = 'NotionalType';
